import { getRegCart } from '../../selectors/shared';
import { RESTORE_REG_CART_PENDING, RESTORE_REG_CART_SUCCESS } from './actionTypes';
import qs from 'querystring';
import { redirectToPage, retryLoadPage, stripRetryAttempt } from '../../pathInfo';
import { getRestoreErrors } from '../errors';
import { logoutRegistrant } from '../../registrantLogin/actions';
import { restoreTravelRegistration } from '../../travelCart';
import Logger from '@cvent/nucleus-logging';

const LOG = new Logger('redux/registrationForm/regCart/restore');

/**
 * Retrieves a RegCart from service.
 * This only works when user session is alive (server-side session is active and browser have identifier cookie)
 */
export function restoreRegistration(regCartId) {
  return async (dispatch, getState) => {
    const { accessToken, clients: { regCartClient } } = getState();
    // Only need to restore a reg cart once.
    let regCartIdFromState = (getRegCart(getState()) || {}).regCartId;
    if (regCartIdFromState === regCartId) return;
    dispatch({ type: RESTORE_REG_CART_PENDING });
    const isRetryAttempt = qs.parse(window.location.search.slice(1)).retryAttempt;
    let regCart = {};
    try {
      regCart = await regCartClient.getRegCart(accessToken, regCartId);
      // Do not restore paymentInfo. Do not clear during failed: needed for 3d secure
      if (!(regCart.paymentInfo && regCart.paymentInfo.thirdPartyRedirectUrl
        && regCart.paymentInfo.paymentStatus === 'PaymentFailed')) {
        regCart.paymentInfo = null;
      }
      // Strip off the retry attempt querystring value if the reg cart get is successful on a retry.
      if (isRetryAttempt) {
        stripRetryAttempt();
      }
      dispatch({ type: RESTORE_REG_CART_SUCCESS, payload: { regCart } });
    } catch (error) {
      LOG.info(`Failed to restore regCart ${regCartId}`, error);
      // PROD-46502: In the case of reg cart id conflict, we want to refresh the page, as they have likely
      // used the back button and the original page is out of date.
      if (getRestoreErrors.isRegCartIdConflict(error)) {
        // If this is the second time this is happening, something is wrong that can't be fixed with a reload
        // Log out and redirect to summary
        if (isRetryAttempt !== undefined && isRetryAttempt === 'true') {
          // We don't want to maintain this retryAttempt querystring value when they are redirected to summary.
          stripRetryAttempt();
          await dispatch(logoutRegistrant());
          await dispatch(redirectToPage('summary'));
          return;
        }
        // Otherwise attempt a reload to fix the conflict.
        retryLoadPage();
        return;
      }
      throw error;
    }
    await dispatch(restoreTravelRegistration(regCart));
  };
}

/**
 * Restores a registration from another tab
 */
export function restoreRegistrationFromOtherTab(
  regCart, regCartPayment, regCartPricing,
  modificationStartRegCart) {
  return {
    type: RESTORE_REG_CART_SUCCESS,
    payload: { regCart, regCartPayment, regCartPricing, modificationStartRegCart }
  };
}
